import { createAsyncThunk } from '@reduxjs/toolkit';

import { MosaferatiApiPaths } from 'Feature/Mosaferati/Common/Constant/MosaferatiApiPaths';
import { MosaferatiHttpGetService } from 'Feature/Mosaferati/Common/Services/MosaferatiHttpService';

export const printElhaghiyehMosaferati = createAsyncThunk(
  'Mosaferati/printElhaghiyehMosaferati',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.PrintElhaghiyehMosaferati}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const getElhaghiyehHayeSadereh = createAsyncThunk('Mosaferati/getElhaghiyehHayeSadereh', async () => {
  return await MosaferatiHttpGetService({
    url: `${MosaferatiApiPaths.BimehNameh.GetElhaghiyehHayeSadereh}`,
  });
});
